import { filter, withLatestFrom, mergeMap } from 'rxjs/operators';
import { Epic } from 'redux-observable';
import { PayloadAction } from '@reduxjs/toolkit';
import { Routes, SettingsRoutes } from '../../../../routes';
import {
  routingOnRoute,
  routingOnRouteToDashboard,
  routingOnRouteToInbox,
  routingOnRouteToReceipts,
  routingOnRouteToReports,
  routingOnRouteToSettings,
} from '..';
import { push } from 'redux-first-history';
import { RootState } from '../../../../store';
import { getRoutingInfo, pushQuery } from '../utils';

export const RoutingToEpic: Epic<any, any, RootState> = (action$, state$) =>
  action$.pipe(
    filter(routingOnRoute.match),
    withLatestFrom(state$),
    mergeMap(([{ payload }, state]) => {
      const { fromLocation, toLocation } = getRoutingInfo(payload);
      const nextActions: PayloadAction<any>[] = [];

      switch (fromLocation.path) {
        default:
          break;
      }

      switch (toLocation.path) {
        case Routes.Root: {
          nextActions.push(
            routingOnRouteToDashboard(toLocation.queryParams),
            pushQuery({ path: toLocation.path }),
          );
          break;
        }
        case Routes.Receipts: {
          nextActions.push(
            routingOnRouteToReceipts(toLocation.queryParams),
            pushQuery({ path: toLocation.path }),
          );
          break;
        }
        case Routes.Inbox: {
          nextActions.push(
            routingOnRouteToInbox(toLocation.queryParams),
            pushQuery({ path: toLocation.path }),
          );
          break;
        }
        case Routes.Reports: {
          nextActions.push(
            routingOnRouteToReports(toLocation.queryParams),
            pushQuery({ path: toLocation.path }),
          );
          break;
        }
        case Routes.Settings: // Match the exact '/settings' route
        default:
          if (toLocation.path.startsWith(Routes.Settings)) {
            nextActions.push(
              routingOnRouteToSettings(toLocation.path as SettingsRoutes),
              pushQuery({ path: toLocation.path }),
            );
          } else {
            // Default handling for other routes
            if (payload.queryParams) {
              nextActions.push(pushQuery(toLocation));
            } else {
              nextActions.push(push(toLocation.path));
            }
          }
          break;
      }

      return nextActions;
    }),
  );
